import { render, staticRenderFns } from "./AddAgentStaff.vue?vue&type=template&id=1aba0b76&scoped=true"
import script from "./AddAgentStaff.vue?vue&type=script&lang=ts"
export * from "./AddAgentStaff.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aba0b76",
  null
  
)

export default component.exports